import { render, staticRenderFns } from "./EventsList.vue?vue&type=template&id=4bf4e660&scoped=true&"
import script from "./EventsList.vue?vue&type=script&lang=ts&"
export * from "./EventsList.vue?vue&type=script&lang=ts&"
import style0 from "./EventsList.vue?vue&type=style&index=0&id=4bf4e660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf4e660",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VTab,VTabItem,VTabs})
